// src/pages/admin/AdminUsers.js
import React, { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);

  const load = async () => {
    const res = await api.get("/admin/users");
    setUsers(res.data || []);
  };

  useEffect(() => {
    load(); // ✅ DO NOT RETURN PROMISE
  }, []);

  const removeUser = async (id) => {
    if (!window.confirm("Delete user?")) return;
    await api.delete(`/admin/users/${id}`);
    load();
  };

  return (
    <div className="card-glass p-6">
      <h2 className="text-xl font-bold mb-6">Users</h2>

      <div className="overflow-x-auto">
        <table className="table-glass">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Balance</th>
              <th>Role</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => (
              <tr key={u._id}>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td>₹ {u.balance || 0}</td>
                <td>{u.role}</td>
                <td>
                  <button
                    onClick={() => removeUser(u._id)}
                    className="btn-danger-sm"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>
    </div>
  );
}
